import { useAuthStore } from "@/stores/auth.store";

export const useAuth = () => {
	const user = useAuthStore((s) => s.user);
	const accessToken = useAuthStore((s) => s.accessToken);
	const refreshToken = useAuthStore((s) => s.refreshToken);
	const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
	const logout = useAuthStore((s) => s.logout);

	return {
		user,
		accessToken,
		refreshToken,
		/** @deprecated alias rétro-compat */
		token: accessToken,
		isAuthenticated,
		logout,
	};
};
